// Language display names
export const languageNames = {
	en: 'English',
	es: 'Español',
	fr: 'Français',
	'fr-ca': 'Français (Canada)',
	de: 'Deutsch',
	it: 'Italiano',
	pt: 'Português',
	zh: '中文',
	ja: '日本語',
	ko: '한국어'
};
